var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "ad18a731-ed77-4085-88b7-419d3fe4f2f8",
    version: "0.0.21",
    organization: "taylor",
    project: "heroine",
    branch: "master",
    folder: "/Users/taylorpoe/.haiku/projects/taylor/heroine",
    username: "taylor+taylor@haiku.ai",
    root: "https://cdn.haiku.ai/e062580c-8941-425f-9ce7-f01d8d3a6bef/07ee961d5f9b270810efecb4f5013685c38388c4/",
    core: "4.3.0",
    title: "Codefaux",
    type: "haiku",
    relpath: "code/codefaux/code.js"
  },
  options: {},
  states: {
    finished: { type: "boolean", value: false, edited: true },
    playing: { type: "string", value: "none", edited: true },
    greenFinished: { type: "boolean", value: false, edited: true },
    pinkFinished: { type: "boolean", value: false, edited: true },
    blueFinished: { type: "boolean", value: false, edited: true },
    purpFinished: { type: "boolean", value: false, edited: true },
    orangeFinished: { type: "boolean", value: false, edited: true }
  },
  eventHandlers: {
    "haiku:Codefaux-30d3044932bd146d": {
      playKids: {
        handler: function(component, element, target, event) {
          var color = arguments[1];
          var finished = color + "Finished";
          this.getDefaultTimeline().pause();
          this.setState({ playing: color });
          this.getDefaultTimeline().gotoAndPlay(0);
          setTimeout(() => {
            this.setState({ [finished]: true });
          }, 800);
        }
      },
      "timeline:Default:42": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      }
    },
    "haiku:b5f106f01a31": {},
    "haiku:Bar-Yellow-1b56a60c7942e4fd": {
      click: {
        handler: function(component, element, target, event) {
          this.send("siblings", "playKids", "orange");
        }
      }
    },
    "haiku:Bar-Purple-10b0f66d5861c98d": {
      click: {
        handler: function(component, element, target, event) {
          this.send("siblings", "playKids", "purp");
        }
      }
    },
    "haiku:Bar-Blue1-a25e7e9a48902dec": {
      click: {
        handler: function(component, element, target, event) {
          this.send("siblings", "playKids", "blue");
        }
      }
    },
    "haiku:Bar-Blue2-c88bd31ffdc0c7a9": {
      click: {
        handler: function(component, element, target, event) {
          this.send("siblings", "playKids", "blue");
        }
      }
    },
    "haiku:Bar-Pink-d115909a337267a1": {
      click: {
        handler: function(component, element, target, event) {
          this.send("siblings", "playKids", "pink");
        }
      }
    },
    "haiku:Bar-Green-4dc3cfc3e0d302fc": {
      click: {
        handler: function(component, element, target, event) {
          this.send("siblings", "playKids", "green");
        }
      }
    }
  },
  timelines: {
    Default: {
      "haiku:code-editor-b20ed48d6f8b3a6d": {
        "translation.x": 1073,
        "translation.y": 206
      },
      "haiku:Codefaux-30d3044932bd146d": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 459.0530152819583,
        "sizeAbsolute.y": 401.9749550725537,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:4211df356d02": { x: 0, y: 0, width: 346, height: 282, rx: 16 },
      "haiku:2d8f89858786": {
        x: "-28.6%",
        y: "-30.9%",
        width: "157.2%",
        height: "170.2%",
        filterUnits: "objectBoundingBox"
      },
      "haiku:474cfe9e8254": {
        dx: 0,
        dy: 12,
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
      },
      "haiku:d0dbb2762153": {
        stdDeviation: 31,
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1"
      },
      "haiku:0212bc2ebb26": {
        values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
        in: "shadowBlurOuter1"
      },
      "haiku:9437b2f9bf3e": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:659b28ff3b50": { "translation.x": -1012, "translation.y": -157 },
      "haiku:8434b006eb55": { "translation.x": 1073, "translation.y": 206 },
      "haiku:7e1591a233d4": {
        fill: "black",
        fillOpacity: 1,
        filter: "url(#09a814c24eae)",
        "xlink:href": "#69467ca45add"
      },
      "haiku:ee5df4d45b9f": {
        fill: "#1A2125",
        fillRule: "evenodd",
        "xlink:href": "#69467ca45add"
      },
      "haiku:00c938e96ad0": {
        fill: "#343F41",
        fillRule: "nonzero",
        "translation.x": 49,
        "translation.y": 51
      },
      "haiku:dfdaa2c3e7db": { x: 0, y: 0, width: 115, height: 10, rx: 5 },
      "haiku:b0bb4ee77db3": { x: 70, y: 41, width: 58, height: 10, rx: 5 },
      "haiku:49df58b0a6c7": { x: 182, y: 82, width: 38, height: 10, rx: 5 },
      "haiku:a991dcf9452e": { x: 109, y: 165, width: 58, height: 10, rx: 5 },
      "haiku:7788cf587148": { x: 0, y: 123, width: 38, height: 10, rx: 5 },
      "haiku:ad1b9b5da5c6": { x: 0, y: 82, width: 124, height: 10, rx: 5 },
      "haiku:640573cb69e3": { x: 134, y: 82, width: 38, height: 10, rx: 5 },
      "haiku:f38326ebeb2f": { x: 128, y: 0, width: 81, height: 10, rx: 5 },
      "haiku:b867d595b815": { x: 0, y: 41, width: 58, height: 10, rx: 5 },
      "haiku:a6c054d898f1": { x: 51, y: 123, width: 158, height: 10, rx: 5 },
      "haiku:af53e45e6edf": { x: 0, y: 165, width: 95, height: 10, rx: 5 },
      "haiku:Bar-Yellow-1b56a60c7942e4fd": {
        "translation.x": 106.144,
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 95,
        "style.margin": "0",
        "style.position": "absolute",
        "sizeMode.x": 1,
        "sizeAbsolute.y": 10,
        "translation.y": 269,
        "style.zIndex": 2,
        opacity: {
          "0": {
            value: Haiku.inject(
              function(orangeFinished, playing) {
                return orangeFinished || playing == "orange" ? 1 : 0;
              },
              "orangeFinished",
              "playing"
            ),
            edited: true
          }
        },
        "scale.x": {
          "0": {
            value: Haiku.inject(
              function(orangeFinished, playing) {
                return orangeFinished && playing != "orange" ? 1 : 0.01;
              },
              "orangeFinished",
              "playing"
            ),
            edited: true,
            curve: "easeOutCubic"
          },
          "700": { value: 1, edited: true }
        },
        "origin.x": 0.008,
        "origin.y": 0.501,
        "style.cursor": { "0": { value: "pointer", edited: true } }
      },
      "haiku:Page-1-498600858e10a2b4": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-Copy-9-b1b2cbeb3b994196": {
        fill: "#FFB150",
        fillRule: "nonzero",
        "translation.x": -1122,
        "translation.y": -422
      },
      "haiku:b5f106f01a31": {
        "sizeMode.y": 1,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 468,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 404,
        "style.margin": "0",
        "translation.x": 229.52650764097916,
        "translation.y": 200.98747753627686,
        "style.zIndex": 1,
        "rotation.x": 0,
        "rotation.y": 0,
        "rotation.z": 0,
        "translation.z": 0
      },
      "haiku:bar-yellow-05cac1743979424a": {
        x: 49,
        y: 216,
        width: 95,
        height: 10,
        rx: 5
      },
      "haiku:Bar-Purple-10b0f66d5861c98d": {
        "translation.x": 157.615,
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 158,
        "style.margin": "0",
        "style.position": "absolute",
        "sizeMode.x": 1,
        "sizeAbsolute.y": 10,
        "translation.y": 227.417,
        "style.zIndex": 3,
        opacity: {
          "0": {
            value: Haiku.inject(
              function(purpFinished, playing) {
                return purpFinished || playing == "purp" ? 1 : 0;
              },
              "purpFinished",
              "playing"
            ),
            edited: true
          }
        },
        "scale.x": {
          "0": {
            value: Haiku.inject(
              function(purpFinished, playing) {
                return purpFinished && playing != "purp" ? 1 : 0.01;
              },
              "purpFinished",
              "playing"
            ),
            edited: true,
            curve: "easeOutCubic"
          },
          "700": { value: 1, edited: true }
        },
        "origin.x": 0.001,
        "origin.y": 0.54,
        "style.cursor": { "0": { value: "pointer", edited: true } }
      },
      "haiku:Page-1-ec55e6132d9273ab": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-Copy-9-a1a431e634372736": {
        fill: "#AC5FD6",
        fillRule: "nonzero",
        "translation.x": -1173,
        "translation.y": -380
      },
      "haiku:code-editor-428ae864bb1c2acd": {
        "translation.x": 1073,
        "translation.y": 206
      },
      "haiku:bar-purple-8976d98cfb72d5a1": {
        x: 100,
        y: 174,
        width: 158,
        height: 10,
        rx: 5
      },
      "haiku:Bar-Blue1-a25e7e9a48902dec": {
        "translation.x": 106.422,
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 124,
        "style.margin": "0",
        "style.position": "absolute",
        "sizeMode.x": 1,
        "sizeAbsolute.y": 10,
        "translation.y": 184.832,
        "style.zIndex": 4,
        opacity: {
          "0": {
            value: Haiku.inject(
              function(blueFinished, playing) {
                return blueFinished || playing == "blue" ? 1 : 0;
              },
              "blueFinished",
              "playing"
            ),
            edited: true
          }
        },
        "scale.x": {
          "0": {
            value: Haiku.inject(
              function(blueFinished, playing) {
                return blueFinished && playing != "blue" ? 1 : 0.01;
              },
              "blueFinished",
              "playing"
            ),
            edited: true,
            curve: "easeOutCubic"
          },
          "700": { value: 1, edited: true }
        },
        "origin.x": 0.002,
        "origin.y": 0.421,
        "style.cursor": { "0": { value: "pointer", edited: true } }
      },
      "haiku:Page-1-7264c2fe869a687c": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-Copy-9-9f46cf0067db6102": {
        fill: "#46B6D8",
        fillRule: "nonzero",
        "translation.x": -1122,
        "translation.y": -339
      },
      "haiku:code-editor-37fdb04f2fbc42e7": {
        "translation.x": 1073,
        "translation.y": 206
      },
      "haiku:bar-blue1-46a69b69d080bf88": {
        x: 49,
        y: 133,
        width: 124,
        height: 10,
        rx: 5
      },
      "haiku:Bar-Blue2-c88bd31ffdc0c7a9": {
        "translation.x": 239.917,
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 38,
        "style.margin": "0",
        "style.position": "absolute",
        "sizeMode.x": 1,
        "sizeAbsolute.y": 10,
        "translation.y": 185.88,
        "style.zIndex": 5,
        opacity: {
          "0": {
            value: Haiku.inject(
              function(blueFinished, playing) {
                return blueFinished || playing == "blue" ? 1 : 0;
              },
              "blueFinished",
              "playing"
            ),
            edited: true
          }
        },
        "scale.x": {
          "0": {
            value: Haiku.inject(
              function(blueFinished, playing) {
                return blueFinished && playing != "blue" ? 1 : 0.01;
              },
              "blueFinished",
              "playing"
            ),
            edited: true,
            curve: "easeOutCubic"
          },
          "700": { value: 1, edited: true }
        },
        "origin.x": 0.01,
        "origin.y": 0.5,
        "style.cursor": { "0": { value: "pointer", edited: true } }
      },
      "haiku:Page-1-bfd061901ba2ccc4": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-Copy-9-b89b371ac5184f0b": {
        fill: "#46B6D8",
        fillRule: "nonzero",
        "translation.x": -1256,
        "translation.y": -339
      },
      "haiku:code-editor-4d9bc85353911010": {
        "translation.x": 1073,
        "translation.y": 206
      },
      "haiku:bar-blue2-fe96e82416a10eb2": {
        x: 183,
        y: 133,
        width: 38,
        height: 10,
        rx: 5
      },
      "haiku:Bar-Pink-d115909a337267a1": {
        "translation.x": 105.712,
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 58,
        "style.margin": "0",
        "style.position": "absolute",
        "sizeMode.x": 1,
        "sizeAbsolute.y": 10,
        "translation.y": 145.04,
        "style.zIndex": 6,
        opacity: {
          "0": {
            value: Haiku.inject(
              function(pinkFinished, playing) {
                return pinkFinished || playing == "pink" ? 1 : 0;
              },
              "pinkFinished",
              "playing"
            ),
            edited: true
          }
        },
        "scale.x": {
          "0": {
            value: Haiku.inject(
              function(pinkFinished, playing) {
                return pinkFinished && playing != "pink" ? 1 : 0.01;
              },
              "pinkFinished",
              "playing"
            ),
            edited: true,
            curve: "easeOutCubic"
          },
          "700": { value: 1, edited: true }
        },
        "origin.x": -0.004,
        "origin.y": 0.5,
        "style.cursor": { "0": { value: "pointer", edited: true } }
      },
      "haiku:Page-1-673b5708ea896b69": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-Copy-9-64c9f04c6e18e922": {
        fill: "#FF6EA8",
        fillRule: "nonzero",
        "translation.x": -1122,
        "translation.y": -298
      },
      "haiku:code-editor-d2066928138b49ef": {
        "translation.x": 1073,
        "translation.y": 206
      },
      "haiku:bar-pink-e17594aac01abc25": {
        x: 49,
        y: 92,
        width: 58,
        height: 10,
        rx: 5
      },
      "haiku:Bar-Green-4dc3cfc3e0d302fc": {
        "translation.x": 232.686,
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 81,
        "style.margin": "0",
        "style.position": "absolute",
        "sizeMode.x": 1,
        "sizeAbsolute.y": 10,
        "translation.y": 101.744,
        "style.zIndex": 7,
        opacity: {
          "0": {
            value: Haiku.inject(
              function(greenFinished, playing) {
                return greenFinished || playing == "green" ? 1 : 0;
              },
              "greenFinished",
              "playing"
            ),
            edited: true
          }
        },
        "scale.x": {
          "0": {
            value: Haiku.inject(
              function(greenFinished, playing) {
                return greenFinished && playing != "green" ? 1 : 0.01;
              },
              "greenFinished",
              "playing"
            ),
            edited: true,
            curve: "easeOutCubic"
          },
          "700": { value: 1, edited: true }
        },
        "origin.x": -0.015,
        "origin.y": 0.338,
        "style.cursor": { "0": { value: "pointer", edited: true } }
      },
      "haiku:Page-1-c2bf3f9ce0fb28e5": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-Copy-9-3ccc2af22736eb94": {
        fill: "#91EB43",
        fillRule: "nonzero",
        "translation.x": -1250,
        "translation.y": -257
      },
      "haiku:code-editor-356b8a794dcd6304": {
        "translation.x": 1073,
        "translation.y": 206
      },
      "haiku:bar-green-74a3dbb0f28724e0": {
        x: 177,
        y: 51,
        width: 81,
        height: 10,
        rx: 5
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Codefaux-30d3044932bd146d",
      "haiku-title": "Codefaux"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Bar-Green-4dc3cfc3e0d302fc",
          "haiku-title": "bar-green",
          "haiku-source": "designs/heroine.sketch.contents/slices/bar-green.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-c2bf3f9ce0fb28e5", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-Copy-9-3ccc2af22736eb94",
                  id: "Artboard-Copy-9"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "code-editor-356b8a794dcd6304",
                      id: "code-editor"
                    },
                    children: [
                      {
                        elementName: "rect",
                        attributes: {
                          "haiku-id": "bar-green-74a3dbb0f28724e0",
                          id: "bar-green"
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Bar-Pink-d115909a337267a1",
          "haiku-title": "bar-pink",
          "haiku-source": "designs/heroine.sketch.contents/slices/bar-pink.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-673b5708ea896b69", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-Copy-9-64c9f04c6e18e922",
                  id: "Artboard-Copy-9"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "code-editor-d2066928138b49ef",
                      id: "code-editor"
                    },
                    children: [
                      {
                        elementName: "rect",
                        attributes: {
                          "haiku-id": "bar-pink-e17594aac01abc25",
                          id: "bar-pink"
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Bar-Blue2-c88bd31ffdc0c7a9",
          "haiku-title": "bar-blue2",
          "haiku-source": "designs/heroine.sketch.contents/slices/bar-blue2.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-bfd061901ba2ccc4", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-Copy-9-b89b371ac5184f0b",
                  id: "Artboard-Copy-9"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "code-editor-4d9bc85353911010",
                      id: "code-editor"
                    },
                    children: [
                      {
                        elementName: "rect",
                        attributes: {
                          "haiku-id": "bar-blue2-fe96e82416a10eb2",
                          id: "bar-blue2"
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Bar-Blue1-a25e7e9a48902dec",
          "haiku-title": "bar-blue1",
          "haiku-source": "designs/heroine.sketch.contents/slices/bar-blue1.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-7264c2fe869a687c", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-Copy-9-9f46cf0067db6102",
                  id: "Artboard-Copy-9"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "code-editor-37fdb04f2fbc42e7",
                      id: "code-editor"
                    },
                    children: [
                      {
                        elementName: "rect",
                        attributes: {
                          "haiku-id": "bar-blue1-46a69b69d080bf88",
                          id: "bar-blue1"
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Bar-Purple-10b0f66d5861c98d",
          "haiku-title": "bar-purple",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/bar-purple.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-ec55e6132d9273ab", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-Copy-9-a1a431e634372736",
                  id: "Artboard-Copy-9"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "code-editor-428ae864bb1c2acd",
                      id: "code-editor"
                    },
                    children: [
                      {
                        elementName: "rect",
                        attributes: {
                          "haiku-id": "bar-purple-8976d98cfb72d5a1",
                          id: "bar-purple"
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Bar-Yellow-1b56a60c7942e4fd",
          "haiku-title": "bar-orange",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/bar-yellow.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-498600858e10a2b4", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-Copy-9-b1b2cbeb3b994196",
                  id: "Artboard-Copy-9"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "code-editor-b20ed48d6f8b3a6d",
                      id: "code-editor"
                    },
                    children: [
                      {
                        elementName: "rect",
                        attributes: {
                          "haiku-id": "bar-yellow-05cac1743979424a",
                          id: "bar-yellow"
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "b5f106f01a31",
          "haiku-title": "code_bg",
          "haiku-source": "designs/heroine.sketch.contents/slices/code_bg.svg"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "2e418a7749d2" },
            children: [
              {
                elementName: "rect",
                attributes: {
                  "haiku-id": "4211df356d02",
                  "haiku-title": "path-1-de1a91",
                  id: "69467ca45add"
                },
                children: []
              },
              {
                elementName: "filter",
                attributes: {
                  "haiku-id": "2d8f89858786",
                  "haiku-title": "filter-2-de1a91",
                  id: "09a814c24eae"
                },
                children: [
                  {
                    elementName: "feOffset",
                    attributes: { "haiku-id": "474cfe9e8254" },
                    children: []
                  },
                  {
                    elementName: "feGaussianBlur",
                    attributes: { "haiku-id": "d0dbb2762153" },
                    children: []
                  },
                  {
                    elementName: "feColorMatrix",
                    attributes: { "haiku-id": "0212bc2ebb26", type: "matrix" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: {
              "haiku-id": "9437b2f9bf3e",
              "haiku-title": "Page-1",
              id: "f535fd699fda"
            },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "659b28ff3b50",
                  "haiku-title": "Artboard-Copy-9",
                  id: "56f23d8a0dda"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "8434b006eb55",
                      "haiku-title": "code-editor",
                      id: "01e139110d66"
                    },
                    children: [
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "4ae62418182a",
                          "haiku-title": "code_bg",
                          id: "63b1ce381f52"
                        },
                        children: [
                          {
                            elementName: "g",
                            attributes: {
                              "haiku-id": "3d605a8fb611",
                              "haiku-title": "editor",
                              id: "42ce81ae4a3a"
                            },
                            children: [
                              {
                                elementName: "use",
                                attributes: { "haiku-id": "7e1591a233d4" },
                                children: []
                              },
                              {
                                elementName: "use",
                                attributes: { "haiku-id": "ee5df4d45b9f" },
                                children: []
                              }
                            ]
                          },
                          {
                            elementName: "g",
                            attributes: {
                              "haiku-id": "00c938e96ad0",
                              "haiku-title": "code-bars",
                              id: "2d8872271ae2"
                            },
                            children: [
                              {
                                elementName: "rect",
                                attributes: {
                                  "haiku-id": "dfdaa2c3e7db",
                                  "haiku-title": "Rectangle-5",
                                  id: "c4e10c75d9cf"
                                },
                                children: []
                              },
                              {
                                elementName: "rect",
                                attributes: {
                                  "haiku-id": "b0bb4ee77db3",
                                  "haiku-title": "Rectangle-5-Copy-6",
                                  id: "1cb3b1fbefea"
                                },
                                children: []
                              },
                              {
                                elementName: "rect",
                                attributes: {
                                  "haiku-id": "49df58b0a6c7",
                                  "haiku-title": "Rectangle-5-Copy-8",
                                  id: "587cfcddab7f"
                                },
                                children: []
                              },
                              {
                                elementName: "rect",
                                attributes: {
                                  "haiku-id": "a991dcf9452e",
                                  "haiku-title": "Rectangle-5-Copy-10",
                                  id: "87bbb738dc20"
                                },
                                children: []
                              },
                              {
                                elementName: "rect",
                                attributes: {
                                  "haiku-id": "7788cf587148",
                                  "haiku-title": "Rectangle-5-Copy-3",
                                  id: "bc9e30c5a47e"
                                },
                                children: []
                              },
                              {
                                elementName: "rect",
                                attributes: {
                                  "haiku-id": "ad1b9b5da5c6",
                                  "haiku-title": "bar-blue1-copy",
                                  id: "1e29aa47261c"
                                },
                                children: []
                              },
                              {
                                elementName: "rect",
                                attributes: {
                                  "haiku-id": "640573cb69e3",
                                  "haiku-title": "bar-blue2-copy",
                                  id: "5aabbbe0015a"
                                },
                                children: []
                              },
                              {
                                elementName: "rect",
                                attributes: {
                                  "haiku-id": "f38326ebeb2f",
                                  "haiku-title": "bar-green-copy",
                                  id: "679f8c5bbb31"
                                },
                                children: []
                              },
                              {
                                elementName: "rect",
                                attributes: {
                                  "haiku-id": "b867d595b815",
                                  "haiku-title": "bar-pink-copy",
                                  id: "bdef83c0d05c"
                                },
                                children: []
                              },
                              {
                                elementName: "rect",
                                attributes: {
                                  "haiku-id": "a6c054d898f1",
                                  "haiku-title": "bar-purple-copy",
                                  id: "4faf19668c4d"
                                },
                                children: []
                              },
                              {
                                elementName: "rect",
                                attributes: {
                                  "haiku-id": "af53e45e6edf",
                                  "haiku-title": "bar-yellow-copy",
                                  id: "0e86293599ea"
                                },
                                children: []
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/taylor-heroine/code/codefaux/code.js
// module id = 518
// module chunks = 35783957827783